import React from "react";
import { usePdpProduct } from "@/features/pdp/PdpContext";
import { ThumbnailButton } from "./ThumbnailButton";
import type { ShopifyMedia } from "@/store";

export interface ThumbnailGroupProps {
  selectedIndex: number;
  onThumbnailClick: (ind: number) => void;
  className?: string;
  media?: ShopifyMedia[];
  setThumbnailRef?: (index: number, node: HTMLButtonElement | null) => void;
}

export const ThumbnailGroup = ({
  selectedIndex,
  onThumbnailClick,
  className,
  media: mediaProp,
  setThumbnailRef,
}: ThumbnailGroupProps) => {
  const product = usePdpProduct();
  const media = mediaProp ?? product.media;

  if (media.length <= 1) {
    return null;
  }
  return (
    <div
      className={`relative z-10 mx-2 flex ${className || "flex-col"}`}
      role="radiogroup"
      aria-label="Thumbnail images"
    >
      {media.map((item, index) => (
        <ThumbnailButton
          key={item.url}
          ref={(node) => setThumbnailRef?.(index, node)}
          onClick={() => onThumbnailClick(index)}
          alt={`Thumbnail (${index + 1})`}
          selected={index == selectedIndex}
          thumbnailSrc={item.url}
          mediaType={item.mediaType}
        />
      ))}
    </div>
  );
};
